import { PortableTextBlock } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';
import { Perks } from 'components/rebrand/Perks';

import { IQueryParams, ISanityImage, ITrackEventProps } from 'typescriptDefs';
import { ICoverHeroPerks } from 'typescriptDefs/pages/coverOverdraftProtection';

interface Props {
  data: {
    btnText: string;
    heading: PortableTextBlock | PortableTextBlock[];
    image: ISanityImage;
    imageAltText: string;
    perks: ICoverHeroPerks[];
    subheading: string;
    tracking: {
      queryParams: IQueryParams;
      trackEventProps: ITrackEventProps;
    };
  };
}

const Hero = ({ data }: Props) => {
  return (
    <Section className="px-32 pb-64 pt-40 md:px-[unset] md:pb-96 md:pt-64">
      <Container className="mb-96 grid items-center gap-64 md:mb-64 md:grid-cols-2 md:gap-96">
        <div>
          <div
            className={twMerge(
              'mb-16 text-primary-350 md:mb-24 [&_strong]:text-primary-200',
              '[&_figure]:mx-0 [&_figure]:my-0 [&_figure]:mb-24 [&_figure]:max-w-300 [&_img]:!object-contain',
            )}
          >
            <CustomPortableText content={data.heading} />
          </div>
          <p className="mb-32 text-lg md:mb-48 md:text-xl">{data.subheading}</p>
          <GetKOHOBtn
            buttonLocation={data.tracking.trackEventProps.label ?? 'Cover Hero'}
            queryParams={data.tracking.queryParams}
            trackEventProps={data.tracking.trackEventProps}
            buttonClassName="w-full md:w-auto"
          >
            {data.btnText}
          </GetKOHOBtn>
        </div>
        <div className="overflow-hidden rounded-24">
          <GatsbyImage
            className="max-h-388 sm:max-h-520 md:max-h-640"
            alt={data.imageAltText}
            image={data.image.asset.gatsbyImageData}
          />
        </div>
      </Container>
      <Container>
        <Perks perks={data.perks} className="max-[400px]:grid-cols-2" />
      </Container>
    </Section>
  );
};

export default Hero;
